import React, { useState } from "react"
import { Link } from "gatsby"
// import { getAppDownloadUrl } from "./utils/index"

import Logo from "../images/logo.png"
import SparkleAsAService from "../images/sparkle-as-a-service-icon.svg"
import SparkleDocIcon from "../images/sparkle-doc-icon.svg"
import SparkleVasIcon from "../images/sparkle-business-support.svg"
import AboutSparkle from "../images/about-sparkle.svg"
import SparkleCareers from "../images/sparkle-careers.svg"

const Nav = () => {
  const [open, setOpen] = useState(false)

  const handleClickScroll = () => {
    const element = document.getElementById("download")
    if(element){
      element.scrollIntoView({behavior: "smooth"})
    }
  }
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-trans py-3">
        <Link className="navbar-brand" to="/">
          <img
            src={Logo}
            alt="Sparkle Nigeria"
            className="img-fluid"
            width="150"
          />
        </Link>
        <button
          className={
            open
              ? "navbar-toggler hamburger hamburger--stand is-active"
              : "navbar-toggler hamburger hamburger--stand"
          }
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => {
            setOpen(!open)
          }}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-between"
          id="navbarTogglerDemo01"
        >
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            <li className="nav-item mx-lg-3">
              <Link className="nav-link" activeClassName="active" to="/">
                Personal
              </Link>
            </li>
            <li className="nav-item mx-lg-3">
              <Link
                className="nav-link"
                activeClassName="active"
                to="/business"
              >
                Business
              </Link>
            </li>
            <li className="nav-item mx-lg-3">
              <Link
                className="nav-link"
                activeClassName="active"
                to="/event"
              >
                Events
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto mt-2 mt-lg-0 align-lg-center">
            <li className="nav-item mx-lg-3 dropdown">
              <a
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                href="#"
              >
                Features <span className="newBadge" aria-hidden="true"></span>
              </a>
              <div className="dropdown-menu dropdown-large">
                <div className="row">
                  <div className="col-md-6">
                    <div className="wrapper p-4">
                      <h2 className="sparkle-green mb-4">Features</h2>

                      <div className="row mb-2">
                        <div className="col-2">
                          <img
                            src={SparkleAsAService}
                            alt="Sparkle as a Service"
                            width="40"
                          />
                        </div>
                        <div className="col-10">
                          <h3 className="sparkle-deep-blue mb-1">
                            Sparkle as a Service
                          </h3>
                          <p className="mb-0">Our most important feature</p>
                          <sup className="sparkle-green font-italic">
                            (Coming Soon)
                          </sup>
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-2">
                          <img
                            src={SparkleDocIcon}
                            alt="Sparkle as a Service"
                            width="40"
                          />
                        </div>
                        <div className="col-10">
                          <h3 className="sparkle-deep-blue mb-1">
                            Sparkle API Documentation
                          </h3>
                          <p className="mb-0">Setup and build fintech apps</p>
                          <sup className="sparkle-green font-italic">
                            (Coming Soon)
                          </sup>
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-2">
                          <Link to="/business-support">
                            <img
                              src={SparkleVasIcon}
                              alt="Sparkle Business Support"
                              width="40"
                            />
                          </Link>
                        </div>
                        <div className="col-10">
                          <Link to="/sparkle-business-support">
                            <h3 className="sparkle-deep-blue mb-1">
                              Sparkle Business Support
                            </h3>
                            <p className="mb-0">
                              Get CAC, TIN and business support services
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 right p-4">
                    <ul className="list-unstyled mt-4">
                      <li className="my-3">
                        <Link
                          to="/features/sparklepay"
                          activeClassName="active"
                        >
                          SparklePay
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/sparkle-cards"
                          activeClassName="active"
                        >
                          Cards
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/indy" activeClassName="active">
                          Indy
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/stash" activeClassName="active">
                          Stash
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/breakdown" activeClassName="active">
                          Breakdown
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/invoice-and-inventory"
                          activeClassName="active"
                        >
                          Inventory
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/invoice-and-inventory"
                          activeClassName="active"
                        >
                          Invoice
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/split-payment"
                          activeClassName="active"
                        >
                          Tabs
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-3 p-4">
                    <ul className="list-unstyled mt-4">
                      <li className="my-3">
                        <Link
                          to="/features/month-in-view"
                          activeClassName="active"
                        >
                          Month in View
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/payment" activeClassName="active">
                          Payments
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/sparkle-loyalty"
                          activeClassName="active"
                        >
                          Loyalty
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/split-payment"
                          activeClassName="active"
                        >
                          Split Bills
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/investments"
                          activeClassName="active"
                        >
                          Investments
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/taxation" activeClassName="active">
                          Taxation
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/features/payroll" activeClassName="active">
                          Payroll
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link
                          to="/features/sparkle-loan"
                          activeClassName="active"
                        >
                          Loans
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item mx-lg-3 dropdown">
              <Link
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                to="/about-us"
                activeClassName="active"
              >
                About Us
              </Link>
              <div className="dropdown-menu dropdown-large">
                <div className="row">
                  <div className="col-md-6">
                    <div className="wrapper p-4">
                      <h2 className="sparkle-green mb-4">About Us</h2>

                      <div className="row mb-2">
                        <div className="col-2">
                          <img
                            src={AboutSparkle}
                            alt="Brief Overview of Sparkle"
                            width="40"
                          />
                        </div>
                        <div className="col-10">
                          <Link to="/about-us">
                            <h3 className="sparkle-deep-blue mb-1">
                              About Sparkle
                            </h3>
                            <p>Brief Overview of Sparkle</p>
                          </Link>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-2">
                          <img
                            src={SparkleCareers}
                            alt="Sparkle Careers"
                            width="40"
                          />
                        </div>
                        <div className="col-10">
                          <Link to="/careers">
                            <h3 className="sparkle-deep-blue mb-1">Careers</h3>
                            <p>Be part of the Sparkle Tribe</p>
                          </Link>
                        </div>
                      </div>

                      {/*
                      <div className="row">
                        <div className="col-2">
                          <img
                            src={SparkleCareers}
                            alt="Sparkle Careers"
                            width="40"
                          />
                        </div>
                        <div className="col-10">
                          <Link to="/careers">
                            <h3 className="sparkle-deep-blue mb-1">Careers</h3>
                            <p>Be part of the Sparkle Tribe</p>
                          </Link>
                        </div>
                      </div>
                    */}
                    </div>
                  </div>

                  <div className="col-md-3 right p-4">
                    <ul className="list-unstyled mt-4">
                      <li className="my-3">
                        <Link to="/community">Community</Link>
                      </li>
                      <li className="my-3">
                        <Link to="/leadership" activeClassName="active">
                          Leadership
                        </Link>
                      </li>
                      <li className="my-3">
                        <a
                          href="https://sparkleng.statuspage.io/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Platform Status
                        </a>
                      </li>
                      {/* <li className="my-3">
                        <Link to="/sparkle-campus-ambassador" activeClassName="active">
                          Campus Ambassabor
                        </Link>
                      </li> */}
                    </ul>
                  </div>

                  <div className="col-md-3 p-4">
                    <ul className="list-unstyled mt-4">
                      <li className="my-3">
                        <Link to="/blog" activeClassName="active">
                          Blog
                        </Link>
                      </li>
                      <li className="my-3">
                        <Link to="/legal" activeClassName="active">
                          Legal
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            {/* <li className="nav-item mx-lg-3">
              <a
                className="nav-link"
                href="https://store.sparkle.ng"
                target="_blank"
                rel="noreferrer"
              >
                Merchandise
              </a>
            </li> */}
            <li className="nav-item mx-lg-3">
              <Link
                className="nav-link"
                to="/contact-us"
                activeClassName="active"
              >
                Contact
              </Link>
            </li>
            <li className="nav-item mx-lg-3 mt-3 mt-lg-0">
              <button
                className="nav-link download-app px-4"
                onClick={handleClickScroll}
              >
                Get The App
              </button>
            </li>
          </ul>
        </div>
        {/* mobile navigation starts here */}
        <div className={open ? "mobile--img" : "mobile--img__inactive"}>
          <Link className="navbar-brand" to="/">
            <img
              src={Logo}
              alt="Sparkle Nigeria"
              className="img-fluid"
              width="150"
            />
          </Link>
        </div>
        <div
          className={open ? "mobile-active mobile" : "mobile-inactive mobile"}
        >
          <ul className="list-unstyled list--wrapper">
            <li className="nav--list">
              <div className="mobile--div">
                <ul className="list-unstyled with-sub">
                  <li className="mt-0">
                    <Link to="/">Personal</Link>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav--list">
              <div className="mobile--div">
                <ul className="list-unstyled with-sub">
                  <li className="mt-0">
                    <Link to="/business">Business</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav--list">
              <div className="mobile--div">
                <ul className="list-unstyled with-sub">
                  <li className="mt-0">
                    <Link to="/sparkle-business-support">
                      Sparkle Business Support
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav--list">
              <div className="mobile--div">
                <ul className="list-unstyled with-sub">
                  <li className="mt-0">
                    <Link to="/event">Events</Link>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav--list">
              <div className="mobile--div">
                <h3>Features</h3>
                <ul className="list-unstyled with-sub">
                  <li>
                    <Link to="/features/sparklepay"> SparklePay</Link>
                  </li>

                  <li>
                    <Link to="/features/sparkle-cards"> Cards</Link>
                  </li>

                  <li>
                    <Link to="/features/indy"> Indy</Link>
                  </li>

                  <li>
                    <Link to="/features/stash"> Stash</Link>
                  </li>

                  <li>
                    <Link to="/features/breakdown"> Breakdown</Link>
                  </li>

                  <li>
                    <Link to="/features/invoice-and-inventory/">
                      {" "}
                      Inventory
                    </Link>
                  </li>

                  <li>
                    <Link to="/features/split-payment"> Tabs</Link>
                  </li>

                  <li>
                    <Link to="/features/payment"> Payments</Link>
                  </li>

                  <li>
                    <Link to="/features/sparkle-loyalty"> Loyalty</Link>
                  </li>

                  <li>
                    <Link to="/features/split-payment"> Split Bills</Link>
                  </li>

                  {/* <li>
                    <Link to="/features/investmets"> Investment</Link>
                  </li> */}
                  <li>
                    <Link to="/features/taxation"> Taxation</Link>
                  </li>
                  <li>
                    <Link to="/features/payroll"> Payroll</Link>
                  </li>
                  <li>
                    <Link to="/features/sparkle-loan"> Loans</Link>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav--list">
              <div className="mobile--div">
                <h3>About Us</h3>
                <ul className="list-unstyled with-sub">
                  <li>
                    <Link to="/about-us">About Sparkle</Link>
                  </li>

                  <li>
                    <Link to="/leadership">Leadership</Link>
                  </li>

                  <li>
                    <Link to="/careers">Careers</Link>
                  </li>

                  <li>
                    <Link to="/community">Community</Link>
                  </li>

                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>

                  <li>
                    <Link to="/legal">Legal</Link>
                  </li>
                  <li>
                    <a
                      href="https://sparkleng.statuspage.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Platform Status
                    </a>
                  </li>
                </ul>
              </div>
            </li>

            {/* <li className="nav--list">
              <div className="mobile--div">
                <a
                  href="https://merch.sparkle.ng"
                  target="_blank"
                  rel="noreferrer"
                >
                  Merchandise
                </a>
              </div>
            </li> */}

            <li className="nav--list">
              <div className="mobile--div">
                <ul className="list-unstyled with-sub">
                  <li className="mt-0">
                    <Link to="/contact-us">Contact</Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
  )
}

export default Nav
